import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const AdminProtectedRoute: React.FC = () => {
    const { user, loading } = useAuth();
    const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

    useEffect(() => {
        if (user) {
            user.getIdTokenResult().then((idTokenResult) => {
                setIsAdmin(idTokenResult.claims.role === 'admin');
            });
        } else if (!loading) {
            setIsAdmin(false);
        }
    }, [user, loading]);

    if (loading || isAdmin === null) {
        return <div className="p-8 text-center">Checking permissions...</div>;
    }

    if (!isAdmin) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="admin-layout">
            {/* Admin Nav could go here */}
            <div className="bg-slate-100 min-h-screen p-4">
                <header className="mb-4 flex justify-between items-center">
                    <h1 className="text-xl font-bold">Laboda Admin</h1>
                    <span className="text-base">{user?.email}</span>
                </header>
                <Outlet />
            </div>
        </div>
    );
};
